import styled from '@emotion/styled';
import { Typography } from '@mui/material';

const InstructionContainer = styled.div`
    margin-top: 10px;
    background-color: ${({ theme }) => theme.colors.primary.bgLight};
    border: solid 1px ${({ theme }) => theme.colors.primary.main};
    color: ${({ theme }) => theme.colors.black[900]};
    padding: 20px 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    gap: 8px;
`;

const CheckBoxInfoText = styled(Typography)`
    font-size: 14px;
    line-height: 20px;
    width: 90%;
    color: ${({ theme }) => theme.colors.black[900]};
    font-weight: 500;

    ul {
        margin: 8px 0 0 20px;
        padding: 0;
        list-style-type: disc;
    }

    li {
        margin-bottom: 8px;
        line-height: 1.5;
    }
`;

export const FootageInstructions = () => {
    return (
        <InstructionContainer>
            <CheckBoxInfoText>
                Record a continuous 3:30 minute video segmented in this order:
                <ul>
                    <li>
                        <b>3 minute talking state</b>: talk directly to the camera about anything.
                    </li>
                    <li>
                        <b>30 second silent state</b>: just look at the camera with a natural smile and breath.
                    </li>
                </ul>
            </CheckBoxInfoText>
        </InstructionContainer>
    );
};
